// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.footer-shop-links{border-bottom:4px solid #2b2b2b;padding-bottom:clamp(2.6875rem,2.3660714286rem + 1.0714285714vw,3.4375rem);padding-top:60px}.footer-shop-links__list{display:grid;grid-gap:4.95px}@media(min-width:750px){.footer-shop-links__list{grid-template-columns:repeat(3,1fr)}}.footer-shop-links__list a{font-size:20px;font-weight:300}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
